import { FocusRingVariants as _FocusRingVariants, } from './focusRingVariants';
export const FocusRingVariants = _FocusRingVariants;
export const ButtonSizes = {
    Sm: 'sm',
    Md: 'md',
    Lg: 'lg',
};
//# sourceMappingURL=types.js.map